import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import axios from 'axios'
import config from '../../config'
import NoData from '../../Component/NoData'
import Loader from '../../Component/Loader'
import placeImage from '../../images/placeholder.jpg'
import product from '../../images/Icons/product-icon.png'

export default function BusinessCategoryProductList() {
  const { id: businessCategoryId } = useParams()
  const [businessCategoryProductListData, setBusinessCategoryProductListData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [, setIsError] = useState(false)
  
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage
  }

  useEffect(() => {
    const fetchBusinessCategoryProductList = async () => {
      if (!businessCategoryId) return
      
      setIsLoading(true)
      setIsError(false)
      
      try {
        const response = await axios.get(`${config.apiUrl}/business-category-product-list?business_category_id=${businessCategoryId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        });
        
        if (response.data.success && response.data.list) {
          setBusinessCategoryProductListData(response.data.list)
        } else {
          setBusinessCategoryProductListData([])
        }
      } catch (error) {
        console.error('API Error:', error);
        setIsError(true)
        setBusinessCategoryProductListData([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchBusinessCategoryProductList()
  }, [businessCategoryId])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className="container-fluid">
      <div className="showcase-product mrty1">
        <div className="row-hd-txt">
          <div className="row-hd-txt-left">
            <img src={product} alt="icon" />
            <h5>Business Category Products</h5>
          </div>
        </div>

        {businessCategoryProductListData.length > 0 ? (
          <div className="row g-3">
            {businessCategoryProductListData.map((category) => (
              <div key={category.id} className="col-12">
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <h4 className="fw-bold text-primary mb-0">{category.name}</h4>
                  </div>
                </div>

                <div className="row shwc-pd-row">
                  {category.products && category.products.length > 0 ? (
                    category.products.map((productItem) => (
                      <div key={productItem.id} className="col-lg-3 col-md-4 col-6 px-2">
                        <Link to={`/product-list/${productItem.id}`} className="shwc-pd-dt">
                          <figure>
                            <img
                              src={productItem.thumbnail}
                              onError={imageOnError}
                              alt="product"
                            />
                          </figure>
                          <span className="fw-500 text-uppercase">{productItem.name}</span>
                          <button className="quote-btn">Get Best Price</button>
                        </Link>
                      </div>
                    ))
                  ) : (
                    <div className="col-12">
                      <div className="text-center py-4">
                        <small className="text-muted">No products available in this category</small>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  )
}
